import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {BehaviorSubject} from "rxjs/BehaviorSubject";

@Injectable()
export class MainKngContentScrollEvent {
  private _scrollEvent: BehaviorSubject<number>;

  constructor() {
    this._scrollEvent = new BehaviorSubject<number>(0);
  }

  broadcast(topScroll: number) {
    this._scrollEvent.next(topScroll);
  }

  on(): Observable<number> {
    return this._scrollEvent.asObservable();
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/events/MainKngContentScrollEvent.ts